import { useCallback } from 'react';

import { useEventbus } from '../../hooks/useEventbus';

import EventBusInstance from '@core/eventbus';

export const useVideoEvents = (onVideoEvent: (data: { type: string; videoId: string }) => void, videoId: string) => {
  const sendEvent = useCallback(
    <T extends keyof jwplayer.EventParams>(event: jwplayer.EventParams[T] | { type?: string }) => {
      EventBusInstance.dispatch('videoplayer_events', { type: (event as any).type, videoId });
    },
    [videoId],
  );

  useEventbus(onVideoEvent, 'videoplayer_events');

  return { sendEvent };
};
